/* generated by Svelte v3.9.1 */
import {
	SvelteComponent,
	append,
	attr,
	destroy_each,
	detach,
	element,
	init,
	insert,
	listen,
	noop,
	safe_not_equal,
	space,
	text
} from "svelte/internal";
import { PATTERNS } from "src/constants"
import { gamePattern } from "src/store.js"

function get_each_context(ctx, list, i) {
	const child_ctx = Object.create(ctx);
	child_ctx.pattern = list[i];
	child_ctx.i = i;
	return child_ctx;
}

// (13:4) {#each Object.keys(PATTERNS) as pattern, i}
function create_each_block(ctx) {
	var option, t0_value = ctx.pattern + "", t0, t1, option_value_value;

	return {
		c() {
			option = element("option");
			t0 = text(t0_value);
			t1 = space();
			option.__value = option_value_value = ctx.pattern;
			option.value = option.__value;
		},

		m(target, anchor) {
			insert(target, option, anchor);
			append(option, t0);
			append(option, t1);
		},

		p(changed, ctx) {
			option.value = option.__value;
		},

		d(detaching) {
			if (detaching) {
				detach(option);
			}
		}
	};
}

function create_fragment(ctx) {
	var div, label, t_1, select, dispose;

	var each_value = Object.keys(PATTERNS);

	var each_blocks = [];

	for (var i = 0; i < each_value.length; i += 1) {
		each_blocks[i] = create_each_block(get_each_context(ctx, each_value, i));
	}

	return {
		c() {
			div = element("div");
			label = element("label");
			label.textContent = "Pattern";
			t_1 = space();
			select = element("select");

			for (var i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].c();
			}
			attr(select, "name", "pattern");
			attr(div, "class", "form-item");
			dispose = listen(select, "change", onChange);
		},

		m(target, anchor) {
			insert(target, div, anchor);
			append(div, label);
			append(div, t_1);
			append(div, select);

			for (var i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].m(select, null);
			}
		},

		p(changed, ctx) {
			if (changed.PATTERNS) {
				each_value = Object.keys(PATTERNS);

				for (var i = 0; i < each_value.length; i += 1) {
					const child_ctx = get_each_context(ctx, each_value, i);

					if (each_blocks[i]) {
						each_blocks[i].p(changed, child_ctx);
					} else {
						each_blocks[i] = create_each_block(child_ctx);
						each_blocks[i].c();
						each_blocks[i].m(select, null);
					}
				}

				for (; i < each_blocks.length; i += 1) {
					each_blocks[i].d(1);
				}
				each_blocks.length = each_value.length;
			}
		},

		i: noop,
		o: noop,

		d(detaching) {
			if (detaching) {
				detach(div);
			}

			destroy_each(each_blocks, detaching);

			dispose();
		}
	};
}

function onChange ({ target: { value }}) {
  gamePattern.set(value)
}

class Component extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, null, create_fragment, safe_not_equal, []);
	}
}

export default Component;